
  import React from "react"
  import Component from "/home/circleci/responsive-analog-read/docs/src/layouts/index.js"
  import data from "/home/circleci/responsive-analog-read/docs/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js